import type {
  ChangeUserPayload,
  InviteUserPayload,
  OrganizationDetailResponse,
  UpdateOrganizationPayload,
} from "../types/organization";
import { apiService } from "./apiService";
import { getErrorMessage } from "./errorHandling";

export const fetchOrganization = async () => {
  try {
    return apiService<OrganizationDetailResponse>({ method: "get", url: "/organization/detail/" });
  } catch (error) {
    throw getErrorMessage(error);
  }
};

export const updateOrganization = async ({
  data,
  id,
  isMultipart,
}: {
  data: UpdateOrganizationPayload | FormData;
  id: number;
  isMultipart?: boolean;
}) => {
  try {
    return apiService<OrganizationDetailResponse>({
      method: "patch",
      url: `/organization/update/${id}/`,
      data,
      isMultipart,
    });
  } catch (error) {
    throw getErrorMessage(error);
  }
};

export const inviteUser = async (data: InviteUserPayload) => {
  try {
    return apiService<InviteUserPayload>({ method: "post", url: "/organization/add_user/", data });
  } catch (error) {
    throw getErrorMessage(error);
  }
};

export const changeUserRole = async (data: ChangeUserPayload) => {
  try {
    return apiService<ChangeUserPayload>({ method: "patch", url: "/organization/change_user_role/", data });
  } catch (error) {
    throw getErrorMessage(error);
  }
};

export const deleteUser = async (id: number) => {
  try {
    return apiService({ method: "delete", url: `/organization/delete_user/${id}/` });
  } catch (error) {
    throw getErrorMessage(error);
  }
};
